(function () {
  const DEFAULT_THRESHOLD = 5500; // 55,00€ en céntimos
  const REOPEN_KEY = 'sabika_reopen_cart_drawer';

  // Si venimos de una recarga forzada por una acción propia (llavero o
  // upsell), reabre el drawer en cuanto el DOM esté listo.
  if (sessionStorage.getItem(REOPEN_KEY) === '1') {
    sessionStorage.removeItem(REOPEN_KEY);
    const reopenDrawer = () => {
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) return;
      if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        drawer.setAttribute('open', '');
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reopenDrawer);
    } else {
      reopenDrawer();
    }
  }

  class CartGiftGoal extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || DEFAULT_THRESHOLD;
      const jsonEl = this.querySelector('[data-gift-product-json]');
      this.giftData = JSON.parse(jsonEl.textContent);
      this.giftVariantIds = this.giftData.variants.map((v) => String(v.id));

      this.lockedEl = this.querySelector('[data-gift-state="locked"]');
      this.unlockedEl = this.querySelector('[data-gift-state="unlocked"]');
      this.addedEl = this.querySelector('[data-gift-state="added"]');
      this.barFill = this.querySelector('[data-gift-bar]');
      this.goalIcon = this.querySelector('[data-gift-goal-icon]');
      this.remainingEl = this.querySelector('[data-gift-remaining]');
      this.selectedTitleEl = this.querySelector('[data-gift-selected-title]');
      this.changeBtn = this.querySelector('[data-gift-change]');

      this.querySelectorAll('[data-variant-id]').forEach((btn) => {
        btn.addEventListener('click', () => this.selectVariant(btn.dataset.variantId));
      });

      if (this.changeBtn) {
        this.changeBtn.addEventListener('click', () => this.showState('unlocked'));
      }

      this.hookLightweightRefresh();
      this.refresh();
      this.observeDrawerRepaints();

      document.addEventListener('sabika:cart-mutated', () => this.refresh());
    }

    hookLightweightRefresh() {
      if (window.__sabikaLightHooked) return;
      window.__sabikaLightHooked = true;
      const origFetch = window.fetch;
      window.fetch = function (input, init) {
        const url = input instanceof Request ? input.url : input;
        const isCartMutation =
          typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url);
        return origFetch.apply(this, arguments).then((response) => {
          if (isCartMutation) {
            document.dispatchEvent(new CustomEvent('sabika:cart-mutated'));
          }
          return response;
        });
      };
    }

    observeDrawerRepaints() {
      const container = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
      if (!container) return;
      const observer = new MutationObserver(() => this.markGiftRow());
      observer.observe(container, { childList: true, subtree: true });
    }

    markGiftRow() {
      if (!this.lastCart) return;
      const giftLine = this.lastCart.items.find((item) =>
        this.giftVariantIds.includes(String(item.variant_id))
      );
      document.querySelectorAll('[data-gift-line]').forEach((row) => {
        row.removeAttribute('data-gift-line');
      });
      if (!giftLine) return;
      const row = document.getElementById(`CartItem-${giftLine.key}`);
      if (row) row.setAttribute('data-gift-line', 'true');
    }

    async refresh() {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    }

    render(cart) {
      this.lastCart = cart;
      const giftLine = cart.items.find((item) =>
        this.giftVariantIds.includes(String(item.variant_id))
      );
      const nonGiftSubtotal = cart.items.reduce((sum, item) => {
        if (this.giftVariantIds.includes(String(item.variant_id))) return sum;
        return sum + item.final_line_price;
      }, 0);

      const unlocked = nonGiftSubtotal >= this.threshold;

      if (!unlocked) {
        this.showState('locked');
        const remaining = (this.threshold - nonGiftSubtotal) / 100;
        this.remainingEl.textContent =
          remaining.toLocaleString('es-ES', { minimumFractionDigits: 2 }) + '€';
        this.barFill.style.width =
          Math.min(100, (nonGiftSubtotal / this.threshold) * 100) + '%';
        this.goalIcon.classList.remove('cart-gift-goal__goal-icon--reached');
        if (giftLine) this.removeGift();
        this.markGiftRow();
        return;
      }

      this.goalIcon.classList.add('cart-gift-goal__goal-icon--reached');

      if (giftLine) {
        this.showState('added');
        this.selectedTitleEl.textContent = giftLine.variant_title || giftLine.product_title;
      } else {
        this.showState('unlocked');
      }
      this.markGiftRow();
    }

    showState(state) {
      this.lockedEl.hidden = state !== 'locked';
      this.unlockedEl.hidden = state !== 'unlocked';
      this.addedEl.hidden = state !== 'added';
    }

    async selectVariant(variantId) {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const existingGift = cart.items.find((item) =>
        this.giftVariantIds.includes(String(item.variant_id))
      );

      if (existingGift && String(existingGift.variant_id) !== String(variantId)) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: existingGift.key, quantity: 0 }),
        });
      }

      if (!existingGift || String(existingGift.variant_id) !== String(variantId)) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
      }

      // Recarga directa, sin intermediarios: garantiza que la nueva línea
      // se vea en el listado del carrito.
      sessionStorage.setItem(REOPEN_KEY, '1');
      window.location.reload();
    }

    async removeGift() {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const existingGift = cart.items.find((item) =>
        this.giftVariantIds.includes(String(item.variant_id))
      );
      if (!existingGift) return;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: existingGift.key, quantity: 0 }),
      });
    }
  }

  customElements.define('cart-gift-goal', CartGiftGoal);
})();